import { courseManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const courseManagementRouteMetadata: IRouteMetadataObj<
  typeof courseManagementRoutesObj
> = {
  list: {
    title: "courseManagement.index.title",
    description: "courseManagement.index.description",
    lazy: () => import("@/pages/courseManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "BookLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "courseManagement.create.title",
    description: "courseManagement.create.description",
    lazy: () => import("@/pages/courseManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "courseManagement.edit.title",
    description: "courseManagement.edit.description",
    lazy: () => import("@/pages/courseManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher, IRoleEnum.ASSISTANT],
  },
  view: {
    title: "courseManagement.edit.title",
    description: "courseManagement.edit.description",
    lazy: () => import("@/pages/courseManagement/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher, IRoleEnum.ASSISTANT],
  },
};

export const courseManagementRoutes = createRoute<
  typeof courseManagementRoutesObj
>(courseManagementRoutesObj, courseManagementRouteMetadata);
